import React from "react";
import { t } from "i18next";
import { Link } from "react-router-dom";
import routes from "../../../../engine/routes";

export const isCheckedAddress = ({ address, institution, principal, type }) => {
  let defaultProjection = "";
  if (type === typeAddress.postal) {
    defaultProjection = "defaultAddress";
  } else {
    defaultProjection = "defaultLocation";
  }

  if (institution !== null) {
    return institution[defaultProjection] === address._id;
  }

  if (principal !== null) {
    return principal.defaultAddress === address._id;
  }
};

export const typeAddress = {
  maps: "maps",
  postal: "postal",
};

export const renderAdress = (adress, isDefault = false, fromInstitution) => {
  if (adress === null) {
    return " - ";
  }

  if (adress?.type === typeAddress.postal) {
    return (
      <>
        {adress?.external === true && (
          <>
            <Link to={routes.institutions(adress.institution?._id).detail.path}>
              {adress.institution?.name}
            </Link>
            <br />
          </>
        )}
        {adress?.description && <b>{adress.description}</b>}
        {isDefault && <cite> - {t("addressHelper.defaultAddress")}</cite>}
        {adress.principal !== null && adress.principal !== undefined ? (
          <cite>
            {" "}
            - {t("addressHelper.mandant", { name: adress.principal?.name })}
          </cite>
        ) : null}
        {fromInstitution?._id !== adress?.institution?._id ? (
          <cite>
            {" "}
            -{" "}
            {t("addressHelper.institution", { name: adress.institution?.name })}
          </cite>
        ) : null}
        {adress?.external === true && (
          <cite> - {t("addressHelper.externalInstitution")}</cite>
        )}
        <br />
        <span>
          {adress?.beneficiary} {adress?.person && `, ${adress.person}`}
          <br />
          {adress?.street} {adress?.number}
          {adress?.complement && ` - ${adress.complement}`} - {adress?.zip}{" "}
          {adress?.city}
        </span>
      </>
    );
  }

  if (adress?.type === typeAddress.maps) {
    return (
      <>
        {adress.location}{" "}
        {isDefault && <cite> - {t("addressHelper.defaultAddress")}</cite>}{" "}
        <br />
        <b>{adress.maps}</b>
      </>
    );
  }
};

export const renderStringAddress = (address, isDefault = false) => {
  if (!address) {
    return t("addressHelper.noAddress");
  }

  let addressString = "";

  if (address.description) {
    addressString += `${address.description}`;
  }

  if (isDefault) {
    addressString += addressString
      ? ` - ${t("addressHelper.defaultAddress")}`
      : t("addressHelper.defaultAddress");
  }

  if (address.external === true) {
    addressString += addressString
      ? ` - ${t("addressHelper.externalInstitution")}`
      : t("addressHelper.externalInstitution");
  }

  addressString += addressString ? "\n" : "";

  let details = `${address.beneficiary || ""}`;
  if (address.person) {
    details += `, ${address.person}`;
  }

  details += `\n${address.street || ""} ${address.number || ""}`;
  if (address.complement) {
    details += ` - ${address.complement}`;
  }
  details += ` - ${address.zip || ""} ${address.city || ""}`;

  addressString += details;

  return addressString;
};
